var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.509 2.89c.853 0 1.545.692 1.545 1.546V7.27c0 .854-.692 1.546-1.545 1.546h-.345v9.8a2.493 2.493 0 0 1-2.491 2.49H6.328a2.49 2.49 0 0 1-2.49-2.49v-9.8H3.49a1.546 1.546 0 0 1-1.545-1.546V4.436c0-.854.692-1.545 1.545-1.545zM5.037 18.617a1.29 1.29 0 0 0 1.291 1.291h11.345a1.293 1.293 0 0 0 1.29-1.29v-9.8H5.038zm8.854-7.217a.6.6 0 1 1 0 1.2h-3.782a.6.6 0 0 1 0-1.2zM3.49 4.09a.346.346 0 0 0-.345.347V7.27c0 .191.155.346.345.346H20.51c.19 0 .345-.155.345-.346V4.436a.345.345 0 0 0-.345-.346z"
  })));
};
export default SvgArchive;